firebird.controller('contentLibraryModalCtrl', [
    '$rootScope',
    '$scope',
    '$interval',
    'logService',
    '$location',
    '$http',
    '$timeout',
    '$window',
    'config',
    'Upload',
    'meetingService',
    'meetingAPIService',
    'socketService',
    'attendeeService',
    'contentService',
    'analyticsWrapperService',
    'helperService',
    'pollingService',
    'questionService',
    'inputService',
    'brandingService',
    'localizationService',
    function (
        $rootScope,
        $scope,
        $interval,
        logService,
        $location,
        $http,
        $timeout,
        $window,
        config,
        Upload,
        meetingService,
        meetingAPIService,
        socketService,
        attendeeService,
        contentService,
        analyticsWrapperService,
        helperService,
        pollingService,
        questionService,
        inputService,
        brandingService,
        localizationService
    ) {
        var self = this;

        const logger = new LogServiceWrapper(logService, 'contentLibraryModalCtrl');

        self.modalState = 'closed';
        self.attendantId = attendeeService.getAttendantId();

        self.supportedFormats = ['pptx', 'ppt', 'pdf', 'mp4'];
        self.pollingInterval = null;
        self.isSearching = false;
        self.isDirty = false;
        self.isWebinar = meetingService.isWebinar();
        self.filesBeingProcessed = [];
        self.files = [];
        self.fileDownloads = {};
        self.removeFileFromFilesArray = removeFileFromFilesArray;

        self.getContentLibrary = getContentLibrary;
        self.onRefreshContentLibrary = onRefreshContentLibrary;
        self.sendRefreshContentLibraryRequest = sendRefreshContentLibraryRequest;
        self.uploadFile = uploadFile;
        self.shareFile = shareFile;
        self.toggleFile = toggleFile;
        self.deleteFile = deleteFile;
        self.search = search;
        self.searchLostFocus = searchLostFocus;
        self.searchTermChanged = searchTermChanged;
        self.getPlayToolTip = getPlayToolTip;
        self.onSharedFilesDataUpdated = onSharedFilesDataUpdated;
        self.useHandOutFeature = useHandOutFeature;
        self.searchFocused = searchFocused;
        self.searchBlurred = searchBlurred;

        self.isContentInitiating = false;
        self.isContentOwner = false;

        self.isLoadingContent = false;

        self.clearInput = clearInput;

        $scope.$on('refresh-content-library', onRefreshContentLibrary);
        $scope.$on('content-initiating', onContentInit);
        $scope.$on('content-init-cancelled', onContentInitCancelled);
        $scope.$on('content-playing', onContentPlaying);
        $scope.$on('content-stopped', onContentStopped);
        $scope.$on('content-status', onContentStatus);
        $scope.$on('content-status', onContentStatus);
        $scope.$on('shared-files-data-updated', onSharedFilesDataUpdated);

        $rootScope.$on('promoted-to-presenter', init);
        $rootScope.$on('demoted-to-attendee', init);

        $scope.$on('show-modal', onShowModal);
        $scope.$on('hide-modal', onHideModal);

        init();

        ////////////////////////

        function init() {
            if (meetingService.getMeetingType() === 'webinar') {
                logger.log('init', 'get content library');

                getContentLibrary();
            }
        }

        function useHandOutFeature() {
            var handoutEnabled = config.webinar.handout;
            if (handoutEnabled) {
                if (self.isWebinar) {
                    return true;
                }
                return false;
            }
            return false;
        }

        function clearInput() {
            self.isDirty = false;
            $scope.searchAll.name = '';
            digest();
        }

        function processContentLibrary(data) {
            //Success
            self.files = [];
            var didHavePendingFiles = false;
            for (i = 0; i < data.length; i++) {
                if (data[i].status !== 50) {
                    continue;
                }

                var item = {
                    icon: getFileIcon(data[i].fileName),
                    isDoneUploading: true,
                    name: data[i].fileName,
                    percentDone: 100,
                    fsPath: '/' + data[i].userID + '/' + data[i].contentID + '/', //data[i].originalUrl.split('/').reverse()[0],
                    contentType: data[i].contentTypeId,
                    waitingForConversion: false,
                    uploadFailed: false,
                    originalUrl: data[i].originalUrl,
                    contentUrl: data[i].contentUrl,
                    contentId: data[i].contentID,
                    isShared: false,
                    isPlaying: false,
                    pageCount: data[i].totalPages,
                    isConverted: data[i].cloudConvertProcess
                };

                for (j = self.filesBeingProcessed.length - 1; j >= 0; j--) {
                    if (data[i].fileName == self.filesBeingProcessed[j].name) {
                        didHavePendingFiles = true;
                        self.filesBeingProcessed.splice(j, 1);
                    }
                }

                self.files.push(item);
            }

            for (i = 0; i < self.filesBeingProcessed.length; i++) {
                self.files.unshift(self.filesBeingProcessed[i]);
            }

            if (self.filesBeingProcessed.length === 0) {
                if (didHavePendingFiles) {
                    self.sendRefreshContentLibraryRequest();
                }
                if (self.pollingInterval !== null) {
                    $interval.cancel(self.pollingInterval);
                    self.pollingInterval = null;
                }
            }

            self.isLoadingContent = false;

            //Get content status
            socketService.send({
                message: 'retrieve-content-status',
                data: {}
            });

            // Get Shared Files Data
            var msg = {
                message: 'get-shared-files-data',
                data: {},
                callback: self.onSharedFilesDataUpdated
            };
            socketService.send(msg);
        }

        function getContentLibrary() {
            self.isLoadingContent = true;

            //TODO: have the all content check come from the server
            var msg = {
                message: 'get-content-library',
                data: {},
                callback: function (response) {
                    if (Array.isArray(response)) {
                        processContentLibrary(response);
                    } else {
                        //Error
                        self.isLoadingContent = false;
                        logService.log('call to meeting Api Service - getContentLibrary was rejected');
                        self.files = [];
                    }
                }
            };

            socketService.send(msg);
        }

        function getContentTypeExtension(contentType) {
            if (contentType == 2) {
                return 'pdf';
            } else if (contentType == 3) {
                return 'mp4';
            }
        }

        function searchLostFocus() {
            if ($scope.searchAll.name !== '') {
                return;
            }
            self.isSearching = false;
        }

        function resetAllFiles() {
            for (var i = 0; i < self.files.length; i++) {
                self.files[i].isPlaying = false;
            }
        }

        function findFile(filePath) {
            var components = filePath.split('/');
            var contentID = components[4];

            for (var i = 0; i < self.files.length; i++) {
                if (contentID === self.files[i].contentId) {
                    return self.files[i];
                }
            }
            return null;
        }

        function fileTypeIsSupported(fileName) {
            if (fileName === null || fileName === undefined) {
                return false;
            }
            var extension = fileName.toLowerCase().split('.').reverse()[0];
            for (var i = 0; i < self.supportedFormats.length; i++) {
                if (self.supportedFormats[i] === extension) {
                    return true;
                }
            }
            return false;
        }

        function getPlayToolTip(file) {
            var toolTipText = '';

            if (self.isContentInitiating) {
                toolTipText = self.isContentOwner
                    ? localizationService.translate(
                          'WEBINAR_CONTENT_LIBRARY.TOOLTIP.YOU_ARE_ALREADY_PREPARING_TO_SHARE_CONTENT'
                      )
                    : localizationService.translate(
                          'WEBINAR_CONTENT_LIBRARY.TOOLTIP.ANOTHER_ATTENDEE_IS_PREPARING_TO_SHARE_CONTENT'
                      );
            } else {
                toolTipText =
                    file.isPlaying === true
                        ? localizationService.translate('WEBINAR_CONTENT_LIBRARY.TOOLTIP.STOP_PLAYING')
                        : localizationService.translate('WEBINAR_CONTENT_LIBRARY.TOOLTIP.PLAY_FILE');
            }

            return toolTipText;
        }

        function removeFileFromFilesArray(filesArray, file) {
            var filesIndex = -1;
            for (var i = 0; i < filesArray.length; i++) {
                if (filesArray[i].name === file.name) {
                    filesIndex = i;
                    break;
                }
            }

            if (filesIndex !== -1) {
                filesArray.splice(filesIndex, 1);
            }
        }

        function uploadFile(file, fileEvent) {
            //file will be null if it didn't pass ngf-pattern

            //TO-DO
            //mime type might be different for browsers
            if (file === null && fileEvent !== undefined && fileEvent.type == 'click') {
                //work around for ngf-select firing multiple times on click after there was previous attempt at selecting an not accepted file
                return;
            }
            if (file === null || (file !== null && fileTypeIsSupported(file.name) === false)) {
                $window.swal({
                    title: localizationService.translate('WEBINAR_CONTENT_LIBRARY.INVALID_FILE.TITLE'),
                    text: localizationService.translate('WEBINAR_CONTENT_LIBRARY.INVALID_FILE.TEXT'),
                    type: 'error',
                    showCancelButton: false,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('COMMON.OK_TEXT'),
                    closeOnConfirm: true
                });

                analyticsWrapperService.eventTrack('Meeting - Files - Bad File Type', {
                    category: 'Content Library'
                });

                return;
            }

            var postUrl = helperService.getAPIUrl() + '/contentLibrary/upload';
            var fileBeingUploaded = {
                icon: getFileIcon(file.name),
                isDoneUploading: false,
                name: file.name,
                percentDone: 0,
                fsPath: '',
                contentType: '',
                waitingForConversion: true,
                uploadFailed: false
            };
            self.filesBeingProcessed.push(fileBeingUploaded);
            self.files.unshift(fileBeingUploaded);

            var successCallback = function (resp) {
                logService.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);

                //UploadHandler returns a failed upload with status 200, and success=false in the data
                if (resp.data !== undefined && resp.data.success === false) {
                    $window.swal({
                        title: localizationService.translate('WEBINAR_CONTENT_LIBRARY.UPLOAD_FAILED.TITLE'),
                        text: resp.data.message,
                        type: 'error',
                        showCancelButton: false,
                        confirmButtonColor: brandingService.getBaseColor(),
                        confirmButtonText: localizationService.translate('COMMON.OK_TEXT'),
                        closeOnConfirm: true
                    });
                    self.removeFileFromFilesArray(self.filesBeingProcessed, fileBeingUploaded);
                    self.removeFileFromFilesArray(self.files, fileBeingUploaded);
                    return;
                }

                fileBeingUploaded.isDoneUploading = true;

                //start polling
                if (self.pollingInterval === null) {
                    self.pollingInterval = $interval(onRefreshContentLibrary, 2000);
                    logService.log('created polling interval');
                }

                analyticsWrapperService.eventTrack('Meeting - Files - Upload Completed', {
                    category: 'Content Library'
                });
            };
            var errorCallback = function (resp) {
                logService.log('Error status: ' + resp.status);
                fileBeingUploaded.uploadFailed = true;
                analyticsWrapperService.eventTrack('Meeting - Files - Upload Errored', {
                    category: 'Content Library'
                });
            };
            var progressUpdateCallback = function (evt) {
                var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
                fileBeingUploaded.percentDone = progressPercentage;
                logService.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            };

            Upload.upload({
                url: postUrl,
                data: { file: file },
                withCredentials: false,
                headers: { AttendantAuthorization: attendeeService.getAttendantBearerToken() }
            }).then(successCallback, errorCallback, progressUpdateCallback);
        }

        function toggleFile(file) {
            //Prevent file playing/stopping when content is already initiating
            if (self.isContentInitiating) {
                return;
            }

            var fileType = getFileType(file.name);
            var contentType = '';

            if (fileType === 'media') {
                contentType = 'video';
            } else if (fileType === 'presentation') {
                contentType = 'slides';
            }

            if (pollingService.getIsVoting() && contentType === 'video') {
                $window.swal({
                    title: localizationService.translate('WEBINAR_CONTENT_LIBRARY.VIDEO_DURING_POLL.TITLE'),
                    text: localizationService.translate('WEBINAR_CONTENT_LIBRARY.VIDEO_DURING_POLL.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });

                return;
            } else if (questionService.getIsInQandAMode() && contentType === 'video') {
                $window.swal({
                    title: localizationService.translate('WEBINAR_CONTENT_LIBRARY.VIDEO_DURING_QANDA.TITLE'),
                    text: localizationService.translate('WEBINAR_CONTENT_LIBRARY.VIDEO_DURING_QANDA.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });

                return;
            }

            var volumeType = fileType === 'media' ? '/s3/video' : '/s3/png';
            var path = volumeType + file.fsPath;

            if (!contentService.isContentPlaying()) {
                //No content playing, allow slides/video
                contentService.playContent(contentType, path, file);
            } else {
                if (!contentService.isContentPlaying(path)) {
                    //Content is playing, but not currently clicked file...
                    //Prompt user to indicate they will have to stop current content before starting their own
                    contentService.promptUserOverride(contentType, path, file);
                } else {
                    //Tell meeting server to stop current content
                    contentService.stopCurrentContent();
                }
            }

            angular.element('#contentLibrary').modal('hide');
        }

        function shareFile(file) {
            file.isShared = true;
            var fileObj = {};
            fileObj.message = 'new-file-share';
            fileObj.data = {
                name: file.name,
                fileDownloadContentId: file.contentId,
                //ANYAM-69185 host should be removed
                host: helperService.getLocationProtocol() + '://www.' + helperService.getLocationHost()
            };

            socketService.send(fileObj);
        }

        function sendRefreshContentLibraryRequest() {
            var msg = getSocketMessageWith('refresh-content-library', null);
            socketService.send(msg);
        }

        function deleteFile(file) {
            $window.swal(
                {
                    title: localizationService.translate('WEBINAR_CONTENT_LIBRARY.DELETE_FILE.TITLE', {
                        filename: file.name
                    }),
                    text: localizationService.translate('WEBINAR_CONTENT_LIBRARY.DELETE_FILE.TEXT'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('COMMON.YES_TEXT'),
                    cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                    closeOnConfirm: true
                },
                function () {
                    var msg = {
                        message: 'delete-from-content-library',
                        data: { contentId: file.contentId },
                        callback: function (response) {
                            if (response && response.indexOf && response.indexOf('has been deleted') > 0) {
                                logService.log('File deleted');
                                sendRefreshContentLibraryRequest();

                                // Remove shared file
                                if (file.isShared === true) {
                                    var fileObj = {};
                                    fileObj.message = 'files-updated';
                                    fileObj.data = {
                                        name: file.name,
                                        fileDownloadContentId: file.contentId
                                    };

                                    socketService.send(fileObj);
                                }
                            } else {
                                logger.error('deleteFile', 'call to server for deleting file had error', response);
                            }
                        }
                    };

                    socketService.send(msg);
                }
            );

            //delete the specific file from content library
        }

        function getFileType(file) {
            var mediaPattern = /(\.avi|\.mp4|\.mov)$/i;
            var presentationPaatern = /(\.ppt|\.pptx|\.pdf)$/i;
            if (mediaPattern.test(file) === true) {
                return 'media';
            } else if (presentationPaatern.test(file) === true) {
                return 'presentation';
            }
            return null;
        }

        function getSocketMessageWith(message, data) {
            var msg = {
                message: message,
                data: data,
                callback: null
            };

            return msg;
        }

        function getFileIcon(file) {
            var type = getFileType(file);
            if (type == 'media') {
                return 'zmdi-movie-alt';
            } else if (type == 'presentation') {
                return 'zmdi-file';
            }
        }

        function searchTermChanged() {
            if ($scope.searchAll.name === '') {
                self.isDirty = false;
            } else {
                self.isDirty = true;
            }
            digest();
        }

        function search() {
            if (self.isSearching === true) {
                $scope.searchAll.name = '';
                self.isDirty = false;
            }
            self.isSearching = true;
        }

        function updateContentStatus(initiating, owner) {
            logService.log(
                'Updating contentLibraryModalCtrl content status - ' + ' Initiating: ' + initiating + ', Owner:',
                owner
            );

            self.isContentInitiating = initiating;
            self.isContentOwner = owner;

            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function onRefreshContentLibrary() {
            if (meetingService.getMeetingType() === 'webinar' && !self.isLoadingContent) {
                getContentLibrary();
            }
        }

        function onContentInit(e, data) {
            var contentInit = true;
            var contentOwner = false;

            if (data.type === 'slides' || data.type === 'video') {
                contentOwner = data.ownerID === self.attendantId;
            }

            updateContentStatus(contentInit, contentOwner);
        }

        function onContentInitCancelled() {
            var contentInit = false;
            var contentOwner = false;

            updateContentStatus(contentInit, contentOwner);
        }

        function onContentPlaying(e, data) {
            if (data.path) {
                var file = findFile(data.path);
                if (file !== null) {
                    file.isPlaying = true;
                }
            }

            var contentInit = false;
            var contentOwner = self.isContentOwner;

            updateContentStatus(contentInit, contentOwner);
        }

        function onContentStopped(e, data) {
            if (data.path) {
                var file = findFile(data.path);
                if (file !== null) {
                    file.isPlaying = false;
                }
            }

            //this type gets cleared largely in the node reset case ... since it doesn't
            //know what types of files were being played ... just reset them all to false
            if (data.type === '') {
                resetAllFiles();
            }

            var contentInit = false;
            var contentOwner = false;

            updateContentStatus(contentInit, contentOwner);
        }

        function onContentStatus(e, data) {
            if (self.attendantId !== data.requesterID) {
                return;
            }

            if (data.path) {
                var file = findFile(data.path);
                if (file !== null) {
                    file.isPlaying = true;
                }
            }

            var contentInit = data.state === 'initiating';
            var contentOwner = false;

            if (data.type === 'slides' || data.type === 'video') {
                contentOwner = data.ownerID === self.attendantId;
            }

            updateContentStatus(contentInit, contentOwner);
        }

        function onShowModal(e, modalName) {
            if (modalName === 'contentLibrary') {
                self.modalState = 'open';
                digest();
            }
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('contentLibraryModalCtrl') !== -1) {
                self.modalState = 'closed';
                digest();
            }
        }

        function onSharedFilesDataUpdated(e, data) {
            self.fileDownloads = data;
            for (var i = 0; i < self.files.length; i++) {
                if (self.fileDownloads.hasOwnProperty(self.files[i].contentId)) {
                    self.files[i].downloads = self.fileDownloads[self.files[i].contentId].downloads;
                }
            }
        }

        function searchFocused() {
            inputService.incrementInputFocused();
        }

        function searchBlurred() {
            inputService.decrementInputFocused();
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
